import logger from "@/services/Logger";
import Helpers from "@/services/helpers";

const debouncedLog = Helpers.debounce((initiator, message) => {
  logger.log(initiator, message);
}, 100);

import {
  SET_PROGRESS,
  SET_PRELOAD,
  SET_RUNNING,
  SET_PAUSED,
  SET_PLAYER_PLAYLIST,
  SET_VOLUME,
  SET_REPEAT,
  SET_SHUFFLE
} from "@/store/mutation-types";

export default {
  [SET_PROGRESS](state, value) {
    state.progress = value;
  },
  [SET_PRELOAD](state, value) {
    state.preload = value;
  },
  [SET_RUNNING](state, value) {
    state.running = value;
  },
  [SET_PAUSED](state, value) {
    state.paused = value;
  },
  [SET_PLAYER_PLAYLIST](state, playlist) {
    state.playlist = playlist;
  },
  [SET_REPEAT](state, value) {
    state.repeat = value;
    debouncedLog("PLAYER", `REPEAT ${value.toUpperCase()}`);
  },
  [SET_VOLUME](state, value) {
    debouncedLog("PLAYER", `VOLUME ${value}`);
    state.volume = value;
  },
  [SET_SHUFFLE](state, flag) {
    state.shuffle = flag;
    debouncedLog("PLAYER", `SHUFFLE ${flag ? "ENABLED" : "DISABLED"}`);
  }
};
